import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-angle-down',
  templateUrl: './icon-angle-down.component.html',
  styleUrls: ['./icon-angle-down.component.scss']
})
export class IconAngleDownComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
